import { composeWithDevTools } from '@redux-devtools/extension';
import { Store, createStore, applyMiddleware } from 'redux';
import createSagaMiddleware, { Saga, SagaMiddleware } from 'redux-saga';

import sagas from './sagas';
import rootReducer from './root-reducer';
import { initialState as auth } from '@store/branches/auth/reducer';
import { initialState as user } from '@store/branches/user/reducer';
import { initialState as leads } from '@store/branches/leads/reducer';
import { initialState as inspirations } from '@store/branches/inspirations/reducer';
import { initialState as products } from '@store/branches/products/reducer';
import { initialState as projects } from '@store/branches/projects/reducer';
import { initialState as project } from '@store/branches/project/reducer';
import { initialState as chat } from '@store/branches/chat/reducer';
import { initialState as organizations } from '@store/branches/organization/reducer';
import { initialState as holidays } from '@store/branches/holidays/reducer';
import { initialState as customer } from '@store/branches/customer/reducer';
import { initialState as commercialPayments } from '@store/branches/commercialPayments/reducer';
import { initialState as tickets } from '@store/branches/tickets/reducer';
import { initialState as costings } from '@store/branches/builderCosting/reducer';
import { initialState as builder } from '@store/branches/builder/reducer';
import { initialState as dashboard } from '@store/branches/dashboard/reducer';
import { initialState as incentives } from '@store/branches/incentives/reducer';
import { initialState as feedback } from '@store/branches/feedback/reducer';
import { initialState as emailConfig } from '@store/branches/emailConfig/reducer';
import { initialState as imagen } from './branches/imagen/reducer';
import { initialState as aimagine } from './branches/aimagine/reducer';

const initialState = {
	auth,
	user,
	leads,
	inspirations,
	projects,
	project,
	chat,
	builder,
	organizations,
	holidays,
	products,
	customer,
	commercialPayments,
	tickets,
	costings,
	dashboard,
	incentives,
	feedback,
	emailConfig,
	imagen,
	aimagine
};

export const sagaMiddleware: SagaMiddleware = createSagaMiddleware();

export function configureStore(): Store<typeof initialState> {
	const store: Store<typeof initialState> = createStore(
		rootReducer(),
		initialState,
		composeWithDevTools(applyMiddleware(sagaMiddleware))
	);

	sagas.forEach((saga: Saga) => {
		sagaMiddleware.run(saga);
	});

	return store;
}
